import { useTranslation } from "react-i18next";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";

import IconButton from "features/components/IconButton";

import { useShareThread } from "./hooks";

/**
 * Creates a point-in-time share link for the current thread and copies it to the clipboard.
 * Whoever opens the link receives their own copy of the thread as it was when the link was created.
 */
const ShareThreadAction = () => {
  const { t } = useTranslation();
  const { currentThreadId, isDisabled, shareThread } = useShareThread();

  if (!currentThreadId) {
    return null;
  }

  return (
    <IconButton
      onClick={shareThread}
      disabled={isDisabled}
      color="secondary"
      size="small"
      data-testid="duck-share-thread-cta"
      tooltip={t("duck:share_thread")}
    >
      <ShareOutlinedIcon fontSize="small" />
    </IconButton>
  );
};

export default ShareThreadAction;
